import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function MailRookCard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/validation/status").then((r) => setS(r.data)).catch(() => setS({ connected: false })); }, []);
  if (!s) return null;
  return (
    <div className="rounded-xl border border-border bg-card p-6 space-y-3" data-testid="mailrook-card">
      <div className="flex items-center justify-between gap-2">
        <h3 className="font-display font-semibold">Email validation (MailRook)</h3>
        <span data-testid="mailrook-status-pill" className={`whitespace-nowrap shrink-0 text-[11px] font-mono px-2 py-0.5 rounded-full border ${s.connected ? "bg-emerald-500/10 text-emerald-700 border-emerald-500/20" : "bg-amber-500/10 text-amber-700 border-amber-500/20"}`}>
          {s.connected ? "Connected" : "Not connected"}
        </span>
      </div>
      {s.connected ? (
        <p className="text-sm" data-testid="mailrook-credits">
          <span className="font-mono font-semibold">{s.credits_remaining ?? "—"}</span> checks left
          {s.free_today != null && <span className="text-muted-foreground"> ({s.free_today} free today, resets at midnight UTC)</span>}
        </p>
      ) : (
        <p className="text-xs text-muted-foreground">{s.error || "Add a MailRook API key to enable the Validate buttons."}</p>
      )}
      <p className="text-xs text-muted-foreground leading-relaxed">Checks run only when you click Validate. Results are remembered for 30 days, and invalid addresses are skipped in campaigns automatically.</p>
    </div>
  );
}
